import { useEffect } from 'react'

import { useQuery } from '@apollo/client'
import get from 'lodash/get'
import PropTypes from 'prop-types'

import getDisplayName from 'utils/getDisplayName'
import { relayConnectionToArray } from 'utils/transformations/graphql'

import { atlasClient } from 'graphql/client'

import {
  collectionsOrphanOrderQuery,
  collectionsQuery,
} from './AddMoreProductsModal.queries'
import { getAvailableDeliveryCollections } from './AddMoreProductsModal.transformations'

const withCollectionsFormatter = (WrappedComponent) => {
  const Wrapper = (props) => {
    const {
      brandId,
      setCollectionId,
      orderCommonInfo,
      loadingOrderCommonInfo,
      permissions: { isAddStylesWhenShipBeforeLinesheetShipRestricted },
    } = props

    const orderDeliveryStart = get(
      orderCommonInfo,
      'shipping.deliveryWindow.startDate',
      '',
    )

    // TODO(ch79298): Add test

    const retailerId = orderCommonInfo?.retailerProfile?.id
    const { loading: collectionsLoading, data } = useQuery(
      retailerId ? collectionsQuery : collectionsOrphanOrderQuery,
      {
        variables: {
          brandIds: [brandId],
          ...(retailerId && { retailerId }),
        },
        client: atlasClient,
        skip: !brandId,
      },
    )
    const collections = relayConnectionToArray(get(data, 'collections', []))
    // TODO(ch79298): add tests for this
    const filteredCollections = isAddStylesWhenShipBeforeLinesheetShipRestricted
      ? getAvailableDeliveryCollections(collections, orderDeliveryStart)
      : collections

    // TODO(ch79600): Use getCollectionsFormatted to add All Linesheet option to the array

    const defaultCollectionId = get(orderCommonInfo, 'collections[0].id')

    useEffect(() => {
      if (defaultCollectionId) {
        setCollectionId(defaultCollectionId)
      }
      // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [defaultCollectionId])

    return (
      <WrappedComponent
        {...props}
        loading={collectionsLoading || loadingOrderCommonInfo}
        collections={filteredCollections}
      />
    )
  }

  Wrapper.displayName = `withCollectionsFormatter(${getDisplayName(
    WrappedComponent,
  )})`
  Wrapper.propTypes = {
    orderIds: PropTypes.array.isRequired,
    ordersCommonShippingInfoLoading: PropTypes.bool,
    ordersCommonShippingInfo: PropTypes.array.isRequired,
    brandId: PropTypes.string.isRequired,
    permissions: PropTypes.shape({
      isAddStylesWhenShipBeforeLinesheetShipRestricted: PropTypes.bool,
    }),
  }
  Wrapper.defaultProps = {
    ordersCommonShippingInfoLoading: false,
    permissions: {
      isAddStylesWhenShipBeforeLinesheetShipRestricted: false,
    },
  }

  return Wrapper
}

export default withCollectionsFormatter
